/**
 * ヘッダースクロール制御（SP のみ）
 * 下スクロール: data-hidden を付与して非表示
 * 上スクロール: data-hidden を除去して表示
 */

const BP_SM = 640; // @include sm の閾値

const main = () => {
    const header = document.querySelector('.l-header');
    if (!header) return;

    const mq = window.matchMedia(`(max-width: ${BP_SM}px)`);
    let lastY = window.scrollY;

    const onScroll = () => {
        if (!mq.matches) return;

        const currentY = window.scrollY;
        const isScrollingDown = currentY > lastY && currentY > header.offsetHeight;

        header.toggleAttribute('data-hidden', isScrollingDown);
        lastY = currentY;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
};

export default main;
